export const EVENT_EMITTER_EVENTS = {
  ADDRESS_CATEGORY_CHANGED: 'ADDRESS_CATEGORY_CHANGED',
};
